import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home-route').then((m) => m.HOME_ROUTES),
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login-route').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./features/forgot-password/forgot-password-route').then((m) => m.FORGOT_PASSWORD_ROUTES),
  },
  {
    path: 'signup',
    loadChildren: () => import('./features/sign-up/sign-up-route').then((m) => m.SIGNUP_ROUTES),
  },
  {
    path: 'wishlist',
    loadChildren: () => import('./features/wishlist/wishlist-route').then((m) => m.WISHLIST_ROUTES),
  },
  {
    path: 'all-products',
    loadChildren: () => import('./features/all-products/all-products-route').then((m) => m.ALL_PRODUCTS_ROUTES),
  },
  {
    path: 'products',
    loadChildren: () => import('./features/products/products-route').then((m) => m.PRODUCTS_ROUTES),
  },
  {
    path: 'bag',
    loadChildren: () => import('./features/bag/bag-route').then((m) => m.BAG_ROUTES),
  },
  {
    path: 'cart',
    redirectTo: 'bag',
    pathMatch: 'prefix',
  },
  {
    path: 'checkout',
    loadChildren: () => import('./features/checkout/checkout-route').then((m) => m.CHECKOUT_ROUTES),
  },
  {
    path: 'account',
    loadChildren: () => import('./features/account/account-route').then((m) => m.ACCOUNT_ROUTES),
  },
  {
    path: 'where-to-buy',
    loadChildren: () =>
      import('./features/store-locator/store-locator-route').then((m) => m.STORE_LOCATOR_ROUTES),
  },
  {
    path: 'about',
    loadChildren: () => import('./features/about/about-route').then((m) => m.ABOUT_ROUTES),
  },
  {
    path: 'contact',
    loadChildren: () => import('./features/contact/contact-route').then((m) => m.CONTACT_ROUTES),
  },
  {
    path: 'faq',
    loadChildren: () => import('./features/faq/faq-route').then((m) => m.FAQ_ROUTES),
  },
  {
    path: 'blog',
    loadChildren: () => import('./features/blog/blog-route').then((m) => m.BLOG_ROUTES),
  },
  {
    path: 'youtube-testimonials',
    loadChildren: () =>
      import('./features/youtube-testimonials/youtube-testimonials-route').then(
        (m) => m.YOUTUBE_TESTIMONIALS_ROUTES,
      ),
  },
];
